import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { EditArticleComponent } from './components/edit-article/edit-article.component';

const routes: Routes = [{path: '', component: EditArticleComponent}];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class EditArticleRoutingModule { }
